function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 23.64V4.5A4.5 4.5 0 014.5 0h19.14a4.5 4.5 0 013.18 1.32l19.86 19.86a4.5 4.5 0 010 6.37L27.55 46.68a4.5 4.5 0 01-6.37 0L1.32 26.82A4.5 4.5 0 010 23.64zM10.5 6a4.5 4.5 0 100 9 4.5 4.5 0 000-9z"
})));